module.exports = __webpack_public_path__ + "media/theme/itunes__tutorial--6--b-f9ce208a.png";